import React, { useState, useMemo } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import api from '../api/axios'; // Use centralized api instance

const RegisterVehicle = ({ plateNumber, carModels, isCarModelRequired, onRegisterSuccess }) => {
    const [selectedManufacturer, setSelectedManufacturer] = useState('');
    const [selectedCarModel, setSelectedCarModel] = useState('');
    const [error, setError] = useState('');

    const uniqueManufacturers = useMemo(() => {
        // API가 displayOrder 순으로 반환 → 등장 순서 유지
        const seen = new Set();
        const list = [];
        carModels.forEach(m => {
            if (m.manufacturer && !seen.has(m.manufacturer)) {
                seen.add(m.manufacturer);
                list.push(m.manufacturer);
            }
        });
        return list;
    }, [carModels]);

    const modelsByManufacturer = useMemo(() => {
        if (!selectedManufacturer) return [];
        return carModels.filter(m => m.manufacturer === selectedManufacturer).sort((a, b) => a.displayOrder - b.displayOrder || a.modelName.localeCompare(b.modelName));
    }, [carModels, selectedManufacturer]);

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');

        let carModelId = null;
        if (isCarModelRequired) {
            if (!selectedManufacturer || !selectedCarModel) {
                setError('제조사와 모델명을 모두 선택해주세요.');
                return;
            }
            carModelId = selectedCarModel;
        } else if (selectedCarModel) {
            carModelId = selectedCarModel;
        }

        try {
            // 선택된 모델의 매장 사이즈 자동 매핑
            const selectedModel = carModels.find(m => String(m.id) === String(carModelId));
            const autoSizeId = selectedModel?.shopSizeId || null;

            await api.post('/vehicles', { plateNumber, carModelId, vehicle_size_id: autoSizeId });
            if (onRegisterSuccess) {
                onRegisterSuccess(plateNumber);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.msg || err.response?.data?.error || '차량 등록 중 오류가 발생했습니다.';
            setError(errorMessage);
            console.error(err);
        }
    };

    return (
        <Card className="mt-4">
            <Card.Body>
                <Card.Title>신규 차량 등록</Card.Title>
                <Card.Text>차량(<b>{plateNumber}</b>) 정보가 없습니다. {isCarModelRequired ? '아래에서 차종을 선택하여 신규 등록하세요.' : '차량을 시스템에 신규 등록합니다.'}</Card.Text>
                {error && <p className="text-danger mt-2">{error}</p>}
                <Form onSubmit={handleRegister}>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label>제조사 선택{!isCarModelRequired && <span className="text-muted small ms-1">(선택사항)</span>}</Form.Label>
                                <Form.Select value={selectedManufacturer} onChange={e => { setSelectedManufacturer(e.target.value); setSelectedCarModel(''); }}>
                                    <option value="">-- 제조사를 선택하세요 --</option>
                                    {uniqueManufacturers.map(m => <option key={m} value={m}>{m}</option>)}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label>모델명 선택{!isCarModelRequired && <span className="text-muted small ms-1">(선택사항)</span>}</Form.Label>
                                <Form.Select value={selectedCarModel} onChange={e => setSelectedCarModel(e.target.value)} disabled={!selectedManufacturer}>
                                    <option value="">-- 모델명을 선택하세요 --</option>
                                    {modelsByManufacturer.map(model => <option key={model.id} value={model.id}>{model.modelName} ({model.vehicleClass})</option>)}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-end">
                            <Button variant="success" type="submit">등록</Button>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default RegisterVehicle;
